import { RootState } from '@services/store/type'

export const getIsOpenSidebar = (state: RootState) =>
	state.sidebar.isSidebarOpen
